import * as React from "react";
import type { SVGProps } from "react";
const SvgWorld = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2h.005C17.512 2.002 22 6.492 22 12c0 5.51-4.49 10-10 10m7.938-11a7.95 7.95 0 0 0-1.256-3.393 12.7 12.7 0 0 1-2.2.804c.148.84.243 1.713.284 2.589zM15.36 4.741a8 8 0 0 1 1.953 1.285c-.416.17-.85.313-1.291.434a12 12 0 0 0-.662-1.719M12 4c.658 0 1.485 1.039 2.068 2.855-.743.1-1.452.145-2.068.145a16 16 0 0 1-2.068-.145C10.515 5.039 11.342 4 12 4m-2.766 7c.037-.786.118-1.519.231-2.191A18 18 0 0 0 12 9c.446 0 1.384-.024 2.535-.19.113.672.194 1.404.231 2.19zm-2 0c.04-.876.136-1.75.284-2.59a13 13 0 0 1-2.2-.804A7.95 7.95 0 0 0 4.062 11zm1.405-6.259a12 12 0 0 0-.662 1.72 12 12 0 0 1-1.291-.435 8 8 0 0 1 1.953-1.285M16.766 13h3.172a7.95 7.95 0 0 1-1.256 3.394 13 13 0 0 0-2.2-.804c.148-.84.243-1.714.284-2.59m-2.231 2.191A19 19 0 0 0 14.766 13H9.234c.037.786.118 1.518.231 2.19C10.616 15.025 11.554 15 12 15a18 18 0 0 1 2.535.191m-4.603 1.954c.743-.1 1.452-.145 2.068-.145s1.325.044 2.068.145c-.582 1.813-1.407 2.852-2.065 2.855H12c-.658 0-1.485-1.039-2.068-2.855M7.518 15.59A21 21 0 0 1 7.234 13H4.062a7.95 7.95 0 0 0 1.256 3.393 12.7 12.7 0 0 1 2.2-.804m-.832 2.385c.416-.17.85-.313 1.291-.434.188.618.409 1.196.662 1.719a8 8 0 0 1-1.953-1.285m9.337-.434c.44.121.875.265 1.291.434a8 8 0 0 1-1.953 1.285 12 12 0 0 0 .662-1.72"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWorld;
